import React from 'react'
import { useListContext } from 'react-admin';
import { useLocation } from 'react-router';

const ClearFiltersOnRouteChange = (props: any) => {
  const { setFilters } = useListContext();
  const location = useLocation();

  React.useEffect(() => {
    if (!props.enableFilterCheck) {
      setFilters({}, {});
      return;
    }

    if (!location.search?.includes('filter')) {
      setFilters({}, {});
    }
  }, [location.pathname]);

  return null;
};

export default ClearFiltersOnRouteChange
